module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_sapporo@2x-664451f750e403aa8a839c0091270ad4.webp";